import React, {
  Component
} from 'react';
import * as Config from '../../config/Config';
import TilePlayer from './TilePlayer';
import * as User from '../../helpers/User';
import * as Common from '../../helpers/Common';

const $ = window.$;

export default class ImageAudioTile extends Component {

  constructor(props) {
    super(props);
    this.state = {
      answerBlock: "",
      gridAudio: `${Config.rootDomainUrl}admin/girdtileaudio_files/${props.tileData.gridAudio1}`,
      audio2: false,
      palayingrate: '1.0',

    };
    this.DoSomething = this.DoSomething.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  //replay option
  replayoption = (id, aud1, aud2, type, grid_id, tile_id, tile_count, counter) => {
    this.close_popup(id)
    this.playaudio(id, aud1, aud2, type, grid_id, tile_id, tile_count, counter)
  }

  playaudio(id, aud1, aud2, type, grid_id, tile_id, tile_count, counter) {
    const { data, tileData, compData } = this.props;

    $('input[type="button"]').addClass("button-accept");
    $('input[type="button"]').removeAttr('disabled');

    //change all border as default style
    $('#grid_tile ul li').each(function () { $(this).css('border', '3px solid #cccccc'); });
    //change active li border color as blue
    $('#image' + id).css('border', '3px solid #1e7bc0');

    let comp_id = compData.id;
    let seqid = compData.compseq_id;
    let count = counter;
    $('span[id^="audios"]').show();

    $.each($('audio'), function (i, audio) {
      audio.pause();
      audio.currentTime = 0;
    });

    $('div[id^="wrap"]').hide();

    // $('div[id^="audio"]').hide();
    $("div").not("#wrap" + id).removeClass('playing-part');
    let audio = document.getElementById('audios' + id);
    let wrap = document.getElementById('wrap' + id);
    $("#wrap" + id).show();
    $("#wrap" + id).addClass("playing-part");



    if (audio.style.display === 'none' || audio.style.display == ' ') {
      audio.style.display = 'block';
    } else {
      audio.style.display = 'none';
      wrap.style.display = 'block';
      var freshaudio = document.getElementById('myaudio' + id);

      if (freshaudio != null) {
        //alert(freshaudio.duration);
        //if (!isNaN(freshaudio.duration)) {
        if (typeof freshaudio.duration == 'number') {
          freshaudio.currentTime = 0;
          var opt_value = document.getElementById("speed" + id);
          var selected_val = opt_value.options[opt_value.selectedIndex].value;
          freshaudio.playbackRate = this.state.palayingrate;
          freshaudio.play();

          if (type == 1) {
            const { compData } = this.props;
            let request_data = {
              grid_id: grid_id,
              tile_id: tile_id,
              comp_id: compData.id,
              learner_id: User.UserId(),
              compseq_id: compData.compseq_id,
              lroom_id: compData.learning_room_id,
              divider_id: compData.divider_id,
              dlrid: compData.dlr_id,
              tile_count: tile_count
            };

            Common.reactLoader("show", "Please wait...");
            fetch(Config.domainUrl + "girdcomponent/audio-insert", {
              method: "POST",
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
              },
              body: JSON.stringify(request_data),
            }).then((response) => response.json()).then((responseJson) => {
              Common.reactLoader("hide");
              if ($("a.click-button").length > 0) {
                $("a.click-button").show();
              }

              if ($("input.button-accept").length > 0) {
                $("input.button-accept").show();
              }
            });
          }

          if (type == 3) {
            if ($("a.click-button").length > 0) {
              $("a.click-button").show();
            }

            if ($("input.button-accept").length > 0) {
              $("input.button-accept").show();
            }
          }

        } else {
          Common.message("Attention!", "Audio file is missing.", 'warning');
        }
      }
    }
  }

  close_popup(id) {
    $("#showDiv" + id).hide();
    $("#audios" + id).show();
  }

  handleUpdate(rate) {
    this.setState({ palayingrate: rate });
  }

  DoSomething(id) {
    var div = document.getElementById('showDiv' + id);
    $("#wrap" + id).hide();
    div.style.display = 'block';
  }

  audio_two(id, aud1, aud2, value, grid_id, tile_id, row) {
    const { data, tileData, compData, index, learningCompletedStatus } = this.props;
    this.setState({
      gridAudio: `${Config.rootDomainUrl}admin/girdtileaudio_files/${aud2}`,
      audio2: true
    });
    setTimeout(() => {
      let Audio = document.getElementById('myaudio' + id);
      if (Audio != null) {
        if (!isNaN(Audio.duration)) {
          Audio.src = `${Config.rootDomainUrl}admin/girdtileaudio_files/${aud2}`;
          Audio.play();
        }
      }
    }, 100);

    Common.reactLoader("show", "Please wait...");

    let request_data = {
      comp_id: compData.id,
      learner_id: User.UserId(),
      compseq_id: compData.compseq_id,
      lroom_id: compData.learning_room_id,
      divider_id: compData.divider_id,
      dlrid: compData.dlr_id,
      grid_id: grid_id,
      value: value,
      tileData: tileData,
      tile_id: tile_id
    };

    fetch(Config.domainUrl + "girdcomponent/mark-validations", {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + Common.getTokenData()
      },
      body: JSON.stringify(request_data),
    }).then((response) => response.json()).then((responseJson) => {
      let response = responseJson;
      Common.reactLoader("hide");
      // if(learningCompletedStatus!=null){
      //
      // }


      if (response.data.score != 0) {
        $("li#image" + id).addClass("pending");
        $("#showDiv" + id + " > p ").hide();
        $("#showDiv" + id + " > .btn-center ").hide();


      } else {
        $("li#image" + id).addClass("viewed");
        $("#showDiv" + id + " > p ").hide();
        $("#showDiv" + id + " > .btn-center ").hide();
      }

      if ($("a.click-button").length > 0) {

        $("a.click-button").show();
      }

      if ($("input.button-accept").length > 0) {

        $("input.button-accept").show();
      }
    });
  }

  render() {
    const { data, tileData, compData, index } = this.props;
    let mainid = `${tileData.data.tile_id_pk}_${index}`;
    let id = `${compData.id}${tileData.image_tile_count}`;
    return (
      <div>
        <a href="javascript:void(0)">
          <img id="grid_img" src={`${Config.rootDomainUrl}admin/girdtileimages/${tileData.gridImage}`} />
          <img className="grid-dummy-image" src={`images/dummy-img-of.jpg`} />
          <span id={`audios${tileData.data.tile_id_pk}_${index}`} className="audio" onClick={(e) => this.playaudio(mainid, `${tileData.gridAudio1}`, `${tileData.gridAudio2}`, `${data.gridType_no}`, `${data.gridData.grid_id_pk}`, `${tileData.data.tile_id_pk}`, `${data.Tcount}`, `${data.counter}`)}></span>
        </a>
        
        <TilePlayer
          wrapper_id={`wrap${tileData.data.tile_id_pk}_${index}`}
          gridType={data.gridType}
          aud_file={this.state.gridAudio}
          audio2={this.state.audio2}
          mainid={mainid}
          onEnd={this.DoSomething}
          palayingrate={this.props.palayingrate}
          onUpdate={this.handleUpdate}
        />

        {data.gridType == 'Practice' &&
          <div className="play-part" id={`showDiv${tileData.data.tile_id_pk}_${index}`} style={{ display: 'none' }}>
            <a href="javascript:void(0);">
              {/* <div className="close-icon" onClick={(e) => this.close_popup(mainid)} id={`close${tileData.data.tile_id_pk}_${index}`}></div> */}
            </a>
            <p>Is this correct? </p>
            <div className="btn-center" >
              <a href="javascript:void(0);" className="click-yes" id="click" onClick={(e) => this.audio_two(mainid, `${tileData.gridAudio1}`, `${tileData.gridAudio2}`, 1, `${data.gridData.grid_id_pk}`, `${tileData.data.tile_id_pk}`, `${data.Tcount}`)}>Yes</a> <a href="javascript:void(0);" className='click-no' id='click' onClick={(e) => this.audio_two(mainid, `${tileData.gridAudio1}`, `${tileData.gridAudio2}`, 0, `${data.gridData.grid_id_pk}`, `${tileData.data.tile_id_pk}`, `${data.Tcount}`)}>No</a>
            </div>
            <div className="reply-btn"><p>Replay</p><a href="javascript:void(0);" className="reply-btn-click" id="click" onClick={this.replayoption.bind(this, mainid, `${tileData.gridAudio1}`, `${tileData.gridAudio2}`, `${data.gridType_no}`, `${data.gridData.grid_id_pk}`, `${tileData.data.tile_id_pk}`, `${data.Tcount}`, `${data.counter}`)}></a></div>
          </div>
        }

      </div>
    );
  }

}




// WEBPACK FOOTER //
// ./src/lr_dlr_components/grid_partials/ImageAudioTile.js